import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

const RequireSuperAdmin = () => {
  const { isAuthenticated, role, loading } = useAuth();

  if (loading) return null; // or loader

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (Number(role) !== 2) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

export default RequireSuperAdmin;
